import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import { desktopAndAbove } from '@sorare/core/src/style/mediaQuery';

import {
  LandingTitle,
  LandingTitleL,
  LandingTitleM,
  LandingTitleS,
} from 'components/landing/ui/LandingTitle';

import bgFlyAvif from './assets/bg_fly.avif';
import bgFly from './assets/bg_fly.jpg';
import bgJerseysAvif from './assets/bg_jerseys.avif';
import bgJerseys from './assets/bg_jerseys.jpg';
import bgRewardboxAvif from './assets/bg_rewardbox.avif';
import bgRewardbox from './assets/bg_rewardbox.jpg';
import cardsAvif from './assets/cards.avif';
import cards from './assets/cards.png';
import flyAvif from './assets/fly.avif';
import fly from './assets/fly.png';
import jerseysAvif from './assets/jerseys.avif';
import jerseys from './assets/jerseys.png';
import rewardboxAvif from './assets/rewardbox.avif';
import rewardbox from './assets/rewardbox.png';

const Root = styled(Vertical)`
  display: flex;
  flex-direction: column;
  gap: calc(8 * var(--unit));
  align-items: center;
  padding: var(--double-unit);
  width: 100%;
  max-width: 1360px;
  margin: auto;
  @media ${desktopAndAbove} {
    padding: calc(10 * var(--unit)) calc(6 * var(--unit));
  }
`;

const Grid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: calc(7 * var(--unit));

  > :nth-child(1) {
    grid-area: big;
    background-image: image-set(
      url(${bgFlyAvif}) type('image/avif'),
      url(${bgFly})
    );
  }
  > :nth-child(2) {
    grid-area: jerseys;
    background-image: image-set(
      url(${bgJerseysAvif}) type('image/avif'),
      url(${bgJerseys})
    );
  }
  > :nth-child(3) {
    grid-area: tickets;
    background-image: image-set(
      url(${bgRewardboxAvif}) type('image/avif'),
      url(${bgRewardbox})
    );
  }
  > :nth-child(4) {
    grid-area: cards;
    background-image: image-set(
      url(${bgRewardboxAvif}) type('image/avif'),
      url(${bgRewardbox})
    );
  }
  @media ${desktopAndAbove} {
    display: grid;
    gap: calc(6 * var(--unit));
    grid-template:
      'big jerseys jerseys' 314px 'big tickets cards' 350px / minmax(624px, 1fr)
      1fr 1fr;
    > :nth-child(1) {
      min-height: 0;
    }
  }
`;
const Block = styled.article`
  position: relative;
  background-size: cover;
  border-radius: 20px;
  min-height: 260px;
  img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    max-width: 80%;
    @media ${desktopAndAbove} {
      max-width: 100%;
      top: 0;
      transform: none;
    }
  }
`;
const BlockContent = styled.div`
  position: absolute;
  bottom: 0;
  width: 80%;
  padding: var(--double-unit);
`;
export const Win = () => {
  return (
    <Root>
      <LandingTitle>
        <FormattedMessage
          id="BestOfEurope.Win.title"
          defaultMessage="Best prizes in fantasy football"
        />
      </LandingTitle>
      <Grid>
        <Block>
          <picture>
            <source srcSet={flyAvif} type="image/avif" />
            <Img
              src={fly}
              alt=""
              width="624"
              height="554"
              fetchpriority="low"
            />
          </picture>
          <BlockContent>
            <LandingTitleL>
              <FormattedMessage
                id="BestOfEurope.Win.fly"
                defaultMessage="Fly with AC Milan"
              />
            </LandingTitleL>
          </BlockContent>
        </Block>
        <Block>
          <picture>
            <source srcSet={jerseysAvif} type="image/avif" />
            <Img
              src={jerseys}
              alt=""
              width="391"
              height="313"
              fetchpriority="low"
            />
          </picture>
          <BlockContent>
            <LandingTitleM>
              <FormattedMessage
                id="BestOfEurope.Win.jerseys"
                defaultMessage="Official jerseys"
              />
            </LandingTitleM>
          </BlockContent>
        </Block>
        <Block>
          <picture>
            <source srcSet={rewardboxAvif} type="image/avif" />
            <Img
              src={rewardbox}
              alt=""
              width="323"
              height="351"
              fetchpriority="low"
            />
          </picture>
          <BlockContent>
            <LandingTitleS>
              <FormattedMessage
                id="BestOfEurope.Win.boxes"
                defaultMessage="Reward boxes"
              />
            </LandingTitleS>
          </BlockContent>
        </Block>
        <Block>
          <picture>
            <source srcSet={cardsAvif} type="image/avif" />
            <Img
              src={cards}
              alt=""
              width="321"
              height="245"
              fetchpriority="low"
            />
          </picture>
          <BlockContent>
            <LandingTitleS>
              <FormattedMessage
                id="BestOfEurope.Win.cards"
                defaultMessage="Sorare{br}cards"
                values={{ br: <br /> }}
              />
            </LandingTitleS>
          </BlockContent>
        </Block>
      </Grid>
    </Root>
  );
};
